export default {
  shouldShowProposalMenuItems: (state) => {
    return state.showProposalsMenuItem;
  },
  hasPendingProposals: (state) => {
    return state.hasPendingProposals;
  },
};
